import { ChartConfig, ChartPadding } from './../models/chart-config';

import * as Chart from 'chart.js';

export class ChartJsConfigHelper {
private chartName: string;
private defaultChartConfig: ChartConfig = {
    layoutPadding: {left: 0, right: 0, top: 18, bottom: 18 },
    legendPosition: 'right',
    datalablesAlign: 'end',
    datalablesAnchor: 'end',
    datalablesColor: 'black',
    pluginPadding: {left: 0, right: 0, top: 0, bottom: 0},
    minPluginLabelsFont: 9,
    maxPluginLabelsFont: 10,
    maxLegendPadding: 5,
    minLegendPadding: 2,
    minLegendFont: 11,
    maxLegendFont: 12,
    minValueLimit: 10
};
constructor (chartName: string) {
    this.chartName = chartName;
    this.canvasToImg = this.canvasToImg.bind(this);
}
   getPieChartJsOptions(chartLabels: Array<string>, datasets: Array<Chart.ChartDataSets>,
        chartConfig?: ChartConfig): Chart.ChartConfiguration {
        chartConfig = this.getConfigChartValue(chartConfig);
        const pluginFontSize = (chartLabels.length > chartConfig.minValueLimit) ? 
        chartConfig.minPluginLabelsFont : chartConfig.maxPluginLabelsFont;
        const legendPadding = (chartLabels.length > chartConfig.minValueLimit) ? 
        chartConfig.minLegendPadding : chartConfig.maxLegendPadding;
        const legendFontSize = (chartLabels.length > chartConfig.minValueLimit) ? 
        chartConfig.minLegendFont : chartConfig.maxLegendFont;
        return {
            type: 'pie',
            data: {
                labels: chartLabels,
                datasets: datasets
            },
            options: {
                animation: {
                    onComplete: this.canvasToImg
                },
                layout: {
                    padding: {
                        left: chartConfig.layoutPadding.left,
                        right: chartConfig.layoutPadding.right,
                        top: chartConfig.layoutPadding.top,
                        bottom: chartConfig.layoutPadding.bottom
                    }
                },
                responsive: false,
                legend: {
                    position: chartConfig.legendPosition, labels: {
                        padding: legendPadding,
                        boxWidth: 10,
                        fontSize: legendFontSize,
                    }
                },
                plugins: {
                    datalabels: {
                        align: chartConfig.datalablesAlign,
                        padding: { left: chartConfig.pluginPadding.left },
                        display: true,
                        anchor: chartConfig.datalablesAnchor,
                        font: {
                            size: pluginFontSize
                        },
                        color: chartConfig.datalablesColor,
                        formatter: function (value, context) {
                            return value + ' %';
                        }
                    }
                }
            }
        };
    }

    private getConfigChartValue(chartConfig: ChartConfig): ChartConfig {
        if (!chartConfig) {
            return this.defaultChartConfig;
        }
        chartConfig.datalablesAlign = String(chartConfig.datalablesAlign) || this.defaultChartConfig.datalablesAlign,
        chartConfig.datalablesAnchor = String(chartConfig.datalablesAnchor) || this.defaultChartConfig.datalablesAnchor,
        chartConfig.datalablesColor = String(chartConfig.datalablesColor) || this.defaultChartConfig.datalablesColor,
        chartConfig.layoutPadding = this.getPaddingValues(chartConfig.layoutPadding, false);
        chartConfig.legendPosition = chartConfig.legendPosition || this.defaultChartConfig.legendPosition;
        chartConfig.pluginPadding = this.getPaddingValues(chartConfig.pluginPadding, true);
        chartConfig.minPluginLabelsFont = Number(chartConfig.minPluginLabelsFont) || this.defaultChartConfig.minPluginLabelsFont;
        chartConfig.maxPluginLabelsFont = Number(chartConfig.maxPluginLabelsFont) || this.defaultChartConfig.maxPluginLabelsFont;
        chartConfig.maxLegendPadding = Number(chartConfig.maxLegendPadding) || this.defaultChartConfig.maxLegendPadding;
        chartConfig.minLegendPadding = Number(chartConfig.minLegendPadding) || this.defaultChartConfig.minLegendPadding;
        chartConfig.minLegendFont = Number(chartConfig.minLegendFont) || this.defaultChartConfig.minLegendFont;
        chartConfig.maxLegendFont = Number(chartConfig.maxLegendFont) || this.defaultChartConfig.maxLegendFont;
        chartConfig.minValueLimit = Number(chartConfig.minValueLimit) || this.defaultChartConfig.minValueLimit;
        return chartConfig;
    }

    private getPaddingValues(chartPadding: ChartPadding, isLabelPadding: boolean): ChartPadding {
        const defaultPadding: ChartPadding = (isLabelPadding) ? this.defaultChartConfig.pluginPadding :
         this.defaultChartConfig.layoutPadding;
         if (!chartPadding) {
             return defaultPadding;
         }
        chartPadding.left = Number(chartPadding.left) || defaultPadding.left;
        chartPadding.right = Number(chartPadding.right) || defaultPadding.right;
        chartPadding.top = Number(chartPadding.top) || defaultPadding.top;
        chartPadding.bottom = Number(chartPadding.bottom) || defaultPadding.bottom;
        return chartPadding;
    }

    private canvasToImg(animation) {
        const url = animation.chart.toBase64Image();
        if (document.getElementById(this.chartName) && !document.getElementById(this.chartName)['src']) {
            document.getElementById(this.chartName)['src'] = url;
            }
    }
}


